<template>
	<div class="change-form">
        <div slot="header" class="header">
            <h4>How can we help you?</h4>
        </div>
        <div class="change-section">
            <h5>Please let us know if you're having any issues with the DoctorPlan app or if you have suggestions on how we can make it better.</h5>
            <textarea 
                v-model="supportText" 
                placeholder="Start typing..."
                rows="30"
                cols="100"
                class="support-input"/>
			<ChangeButtons @change="submitSupport" @cancel="cancel" :name="'Submit'"></ChangeButtons>
        </div>
    </div>
</template>

<script>
import ChangeButtons from './ChangeButtons'

export default {
	name: 'contact-support',

	data() {
		return {
			supportText: null
		}
    },
    mounted() {
    },
    methods: {
        submitSupport() {
			this.$emit('submit', {
				support: this.supportText
			})
		},
		cancel() {
			this.$emit('cancel')
		}
    },
	computed: {
    },
    components: {
        ChangeButtons
    }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>